import { Button, Col, Container, Row } from "react-bootstrap";
import "./sparc/style.css";


export default function EduCarnival() {
    return (
    <Container className="portfolio justified-content">
        <br/>
        <br/>
	  <Row>
        
		<Col sm="12">
			<div align="center">
            
                <Row className="vertical-aligned-logos">
                    <Col sm="4"><img src={process.env.PUBLIC_URL+'/sparc/iitlogo.png'} style={{maxWidth:"100%"}}/></Col>
                </Row>

                <img src={process.env.PUBLIC_URL+'/educarnival/educarnivallogo.jpg'} style={{maxWidth:"25%"}}/>
                
                <h5>16<sup>th</sup> Annual International Conference </h5>
                
                <h6>organized by IIT Delhi on</h6>
                
                <h3 style={{marginTop:"5px"}}>Building a Dream School Team</h3>
                
                <h6>22-23 December 2025</h6>
                
                <h6> at IIT Delhi Campus</h6>
                
            </div>

            <br/>
            <p className="section-heading"><b>Background</b></p> 
            <p>Behind every child who thrives, there is a teacher who guided them, a leader who shaped the curriculum, and a school owner who made sure the doors stayed open. This year, Team EduCarnival invites the School Team at the IIT Delhi Campus to think, dream, and plan together.</p>
            
            <Row>
                <Col md="6" sm="12">
                    <p className="section-heading"><b>For School Founders & Management</b></p>
                    <ol>
                        <li>Investment & Financing for Your School</li>
                        <li>Scale Your School</li>
                        <li>Governance & Compliance for Your School</li>
                        <li>Smart Budgeting for Your School</li>
                        <li>School Boards and Beyond</li>
                        <li>KYL: Know Your Leaders</li>
                    </ol>
                </Col>
                <Col md="6" sm="12">
                    <p className="section-heading"><b>For School Leader & Academic Team</b></p>
                    <ol>
                        <li>AI-Assisted Teaching for Your Classroom</li>
                        <li>High-Impact Teaching Strategies</li>
                        <li>Teaching Fundamentals Refresher</li>
                        <li>Teacher Mentoring Systems</li>
                        <li>Professional Portfolio Building</li>
                        <li>Excellence Showcase Live</li>
                    </ol>
                </Col>
            </Row>
            

            <p className="section-heading"><b>Call for Participation</b></p>
            <Row>
                <Col sm="12" md="3" style={{textAlign:"center", margin:"30px 0"}}>
                    <img src={process.env.PUBLIC_URL+'/educarnival/regqr.png'} width="100%"/>
                    <p>Visit <a href="https://docs.google.com/forms/d/e/1FAIpQLScckqj4OykTW6tQnHzfnNZgmIUbXfzOd3GIbGim7HPd1aOnNA/viewform" target="_blank">Google Form</a> to register</p>
                </Col>
                
                <Col sm="12" md="3" style={{textAlign:"center", margin:"30px 0"}}>
                    <b>School Management & Founder</b><br/><br/>
                    INR 20,750/-<br/><br/>
                    <Button href="https://rzp.io/rzp/4EpzjkXd" target="_blank">Click To Pay <i className="bi bi-arrow-right"></i></Button>                
                </Col>
                
                <Col sm="12" md="3" style={{textAlign:"center", margin:"30px 0"}}>
                    <b>School Leader & Academic Team</b><br/><br/>
                    INR 16,750/-<br/><br/>
                    <Button href="https://rzp.io/rzp/TBDrOgUo" target="_blank">Click To Pay <i className="bi bi-arrow-right"></i></Button>    
                </Col>

                <Col sm="12" md="3" style={{textAlign:"center", margin:"30px 0"}}>
                    <b>Download Brochure</b><br/><br/>
                    to get more details<br/><br/>
                    <Button href={process.env.PUBLIC_URL+'/educarnival/educarnival25.pdf'} target="_blank">Download Brochure <i className="bi bi-arrow-right"></i></Button>
                </Col>
                
            </Row>

            
            {/*<Row>
                <Col sm="12" md="12" style={{marginBottom:"30px"}}>
                    <p className="section-heading"><b>Payment Structure</b></p>
                    <table className="styled-table" width={"100%"}>
                        <tbody>
                        <tr>
                            <td><b>Expiry Date</b></td>
                            <td>
                                <b>Registration Fees<br/>
                                (School Leader & Academic Team)</b>
                            </td>
                            <td>
                                <b>Registratio Fees<br/>
                                (School Management & Founder)</b>
                            </td>
                        </tr>
                        <tr>
                            <td>2:00 pm, Monday 29<sup>th</sup> September 2025</td>
                            <td>INR 13,750/-</td>
                            <td>INR 17,750/-</td>
                        </tr>
                        <tr>
                            <td>2:00 pm, Monday 3<sup>rd</sup> November 2025</td>
                            <td>INR 14,750/-</td>
                            <td>INR 18,750/-</td>
                        </tr>
                        <tr>
                            <td>2:00 pm, Monday 1<sup>st</sup> December 2025</td>
                            <td>INR 15,750/-</td>
                            <td>INR 19,750/-</td>
                        </tr>
                        <tr>
                            <td>2:00 pm, Wednesday 24<sup>th</sup> December 2025</td>
                            <td>INR 16,750/-</td>
                            <td>INR 20,750/-</td>
                        </tr>
                        </tbody>
                    </table>
                </Col>
            </Row>*/}

            <p className="section-heading"><b>Call for Corporate Sponsorship</b></p>
            <Row>
                
                <Col sm="12" md="3" style={{textAlign:"center", margin:"30px 0"}}>
                <b>For Corporate Sponsor</b><br/><br/>
                    <Button href="https://forms.gle/pezJfPrjTKSotQJT8 " target="_blank">Register as Sponsor <i className="bi bi-arrow-right"></i></Button>                
                </Col>
                
            </Row>

            <p className="section-heading"><b>Conference Steering Committee</b></p>
            <Row>
                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/sparc/chariar.jpg'} width="100%"/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Prof Vijayaraghavan M Chariar<br/>		
                        IIT Delhi<br/>
                        <a href="mailto:chariarv@iitd.ac.in">chariarv@iitd.ac.in</a>
                    </p>
                </Col>

                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/educarnival/hchaudhry.jpg'} width="100%" style={{border:"1px solid #ddd"}}/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Prof. Harish Chaudhry<br/>
                        IIT Delhi<br/>
                        <a href="mailto:j.oliver@rmit.edu.au">harishc@dms.iitd.ac.in</a>
                    </p>
                </Col>
            </Row>

            <br/><br/>
            <p className="section-heading"><b>Reserve Your Seat | Request a Call</b></p>
            <Row>
                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/educarnival/himanshu.jpg'} width="100%"/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Himanshu Srivastava<br/>		
                        99904 18600<br/>
                        <a href="mailto:himanshu@eduexcellence.in">himanshu@eduexcellence.in</a>
                    </p>
                </Col>

                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/educarnival/arnab.jpg'} width="100%" style={{border:"1px solid #ddd"}}/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Arnab Chatterjee<br/>
                        84483 85048<br/>
                        <a href="mailto:arnab@eduexcellence.in">arnab@eduexcellence.in</a>
                    </p>
                </Col>
            </Row>

<br/><br/>
            <Row className="vertical-aligned-logos">
                <Col sm="4"><img src={process.env.PUBLIC_URL+'/educarnival/eduexcellence.png'} style={{maxWidth:"100%", maxHeight:"40px"}}/></Col>
                <Col sm="4"><img src={process.env.PUBLIC_URL+'/educarnival/dextres.png'} style={{maxWidth:"100%", maxHeight:"50px"}}/></Col>  
            </Row>

        </Col>
    </Row>
        <br/>
</Container>
    );
}